import { Woonstad_Foundation_Portfolio_Api_Features_Woonstad_Models_AdvertisementDetailV3, Woonstad_Foundation_Portfolio_Api_Features_Woonstad_Models_NieuwbouwTypeDetailV3 } from '@woonstad/api-client-woonstad-aanbod';
import { hasValue } from '@woonstad/helpers-utils';

export const advertDetailCardLandscapeUspsWoonstad = (
  advert: Woonstad_Foundation_Portfolio_Api_Features_Woonstad_Models_AdvertisementDetailV3,
) => {
  const usps = [];

  // Layers is actually the floor number of the entrance
  if (hasValue(advert.objectDetails?.propertySpecification?.layers)) usps.push(advert.objectDetails?.propertySpecification?.layers === 0 ? 'Begane grond' : `${advert.objectDetails?.propertySpecification?.layers}e verdieping`);
  if (advert.objectDetails?.propertySpecification?.surface) usps.push(`${advert.objectDetails?.propertySpecification?.surface}m²`);
  if (advert.objectDetails?.roomSpecification?.rooms) usps.push(`${advert.objectDetails?.roomSpecification?.rooms} kamers`);

  return usps;
};

export const advertDetailCardSquareUspsWoonstad = (
  advert: Woonstad_Foundation_Portfolio_Api_Features_Woonstad_Models_AdvertisementDetailV3,
) => {
  const usps = [];
  // Layers is actually the floor number of the entrance
  if (advert.objectDetails?.propertySpecification?.layers && advert.objectDetails?.propertySpecification?.layers === 0) usps.push('Begane grond');
  if (advert.objectDetails?.propertySpecification?.layers && advert.objectDetails?.propertySpecification?.layers === 1) usps.push('Eerste verdieping');
  if (advert.objectDetails?.propertySpecification?.layers && advert.objectDetails?.propertySpecification?.layers === 2) usps.push('Tweede verdieping');
  if (advert.objectDetails?.propertySpecification?.layers && advert.objectDetails?.propertySpecification?.layers === 3) usps.push('Derde verdieping');
  if (advert.objectDetails?.propertySpecification?.layers && advert.objectDetails?.propertySpecification?.layers > 3) usps.push(`${advert.objectDetails?.propertySpecification?.layers}e verdieping`);
  if (advert.objectDetails?.propertySpecification?.surface) usps.push(`${advert.objectDetails?.propertySpecification?.surface}m²`);
  if (advert.objectDetails?.roomSpecification?.rooms) usps.push(`${advert.objectDetails?.roomSpecification?.rooms} kamers`);

  return usps;
};

export const advertNieuwbouwDetailCardLandscapeUspsWoonstad = (
  advert: Woonstad_Foundation_Portfolio_Api_Features_Woonstad_Models_NieuwbouwTypeDetailV3,
) => {
  const usps = [];

  // Layers is actually the floor number of the entrance
  if (hasValue(advert.layers)) usps.push(advert.layers === 0 ? 'Begane grond' : `${advert.layers}e verdieping`);
  if (advert.surfaceArea) usps.push(`${advert.surfaceArea.min}-${advert.surfaceArea.max}m²`);
  if (advert.rooms) usps.push(`${advert.rooms.min}-${advert.rooms.max} kamers`);

  return usps;
};

export const advertNieuwbouwDetailCardSquareUspsWoonstad = (
  advert: Woonstad_Foundation_Portfolio_Api_Features_Woonstad_Models_NieuwbouwTypeDetailV3,
) => {
  const usps = [];
  // Layers is actually the floor number of the entrance
  if (advert.layers && advert.layers === 0) usps.push('Begane grond');
  if (advert.layers && advert.layers === 1) usps.push('Eerste verdieping');
  if (advert.layers && advert.layers === 2) usps.push('Tweede verdieping');
  if (advert.layers && advert.layers === 3) usps.push('Derde verdieping');
  if (advert.layers && advert.layers > 3) usps.push(`${advert.layers}e verdieping`);
  if (advert.surfaceArea) usps.push(`${advert.surfaceArea.min}-${advert.surfaceArea.max}m²`);
  if (advert.rooms) usps.push(`${advert.rooms.min}-${advert.rooms.max} kamers`);

  return usps;
};
